document.addEventListener("DOMContentLoaded", function () {
  function t(t) {
    $("div.yv-product-slider-item").each(function () {
      $(this).attr("variant-color").toLowerCase() === t.toLowerCase()
        ? $(this).addClass("matched")
        : $(this).removeClass("matched");
    });
  }
  $("ul.list-unstyled.product-loop-variants.circle").on(
    "click",
    "li",
    function () {
      var t = $(this).find("label").text().trim();
      $("div.yv-product-slider-item").each(function () {
        $(this).attr("variant-color").toLowerCase() === t.toLowerCase()
          ? $(this).addClass("matched")
          : $(this).removeClass("matched");
      });
    }
  ),
    $("ul.list-unstyled.product-loop-variants.circle").on(
      "click",
      "li",
      function () {
        var e = $(this).find("label").text().trim();
        t(e),
          console.log("Selected color:", e),
          t(
            $("li.color_option.variant_option.active")
              .find("label")
              .text()
              .trim()
          );
      }
    ),
    document.addEventListener("DOMContentLoaded", function () {
      !(function t() {
        if (
          "Asia/Calcutta" ===
            Intl.DateTimeFormat().resolvedOptions().timeZone ||
          "Asia/Kolkata" === Intl.DateTimeFormat().resolvedOptions().timeZone
        ) {
          $("#flo-buy-now-button").css("display", "block"),
            $("#shopify_buy_now_button_wrapper").css("display", "none");
          return;
        }
        document
          .querySelector("#shopify_buy_now_button_wrapper")
          .style.setProperty("display", "block", "important"),
          document
            .querySelector("#flo-buy-now-button")
            .style.setProperty("display", "none", "important");
      })();
    }),
    document.addEventListener("DOMContentLoaded", () => {
      let t = document.querySelectorAll('script[src*="googletagmanager.com"]');
      t.forEach((t) => t.remove());
    }),
    $(".link-1").on("click", function () {
      var t = $(this).closest(".footer-menu-accordion");
      t.toggleClass("active"),
        t.hasClass("active") &&
          $(".footer-menu-accordion").not(t).removeClass("active");
    });
  let e = document.createElement("script");
  (e.src = "https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js"),
    (e.onload = function () {
      let t = document.createElement("script");
      (t.src = "https://unpkg.com/flickity-fade@1/flickity-fade.js"),
        (t.onload = function () {
          let t = document.querySelector(
            ".banner-section .flickity-slider-active"
          );
          t
            ? new Flickity(t, {
                contain: !0,
                resize: !0,
                fade: !0,
                touchVerticalScroll: !1,
                pageDots: !0,
                prevNextButtons: !1,
                autoPlay: 3e3,
              })
            : console.warn("Carousel element not found");
          var e = document.querySelectorAll(
            ".collection-product-section .carousel-slider-flickity, .slider_container.slider-video-carousel .slider"
          );
          e.forEach((t) => {
            !Flickity.data(t) &&
              (e
                ? new Flickity(t, {
                    wrapAround: !1,
                    cellAlign: "center",
                    dragThreshold: 10,
                    touchVerticalScroll: !1,
                    contain: !0,
                    resize: !0,
                    groupCells: !0,
                    prevNextButtons: !0,
                    pageDots: !1,
                    arrowShape:
                      "M36.7,76.9c1.9,1.4,1.9,3.8,0,5.7c-0.6,0.6-1.6,0.9-2.8,0.9c-0.9,0-1.9-0.3-2.8-0.9L2.2,52.8 c-1.9-1.4-1.9-4.3,0-5.7L30,18.3c1.4-1.4,3.8-1.4,5.2,0c1.9,1.4,1.9,4.3,0,5.7L10.2,50L36.7,76.9z M95.2,46.2c1.9,0,3.8,1.9,3.8,4.3 c0,2.4-1.9,3.8-3.8,3.8H13c-2.4,0-3.8-1.4-3.8-3.8c0-2.4,1.4-4.3,3.8-4.3H95.2z",
                  })
                : console.warn("Carousel element not found"));
          });
           $(".recent-viewed-product-section .recently-viewed-wrapper .new-view-peoducts").flickity({
            wrapAround: true,
            pageDots: false,
            initialIndex: 6,
            cellAlign: 'left',
            accessibility: true,
            autoPlay: false,
            responsive: [
            {
              breakpoint: 1440,
              settings: {
                wrapAround: true,
                pageDots: false,
                initialIndex: 5,
                cellAlign: "left",
                accessibility: true,
                autoPlay: false
              }
            }
          ]
          });
          
        }),
        document.body.appendChild(t);
    }),
    document.body.appendChild(e);

  setTimeout(function() {
    $('video').each(function() {
      var poster = $(this).attr('poster');
      if (poster && poster.startsWith('//')) {
        $(this).attr('poster', 'https:' + poster);
      }
      if (poster && poster.includes('_small')) {
        var newPoster = poster.replace('_small', '');
        $(this).attr('poster', newPoster);
      }
    });
    }, 3000);
  function toggleVisibilityOnScroll() {
    if ($(".single__product .yv-checkout-btn-full-width.yv-checkout-btn").is(":visible")) {
      $(".yv-product-viewbar").removeClass("visible");
    } else {
      $(".yv-product-viewbar").addClass("visible");
    }
  }
  toggleVisibilityOnScroll();
  $(window).on('scroll', function() {
    toggleVisibilityOnScroll();
  });
  $('.productOption').each(function() {
      if ($(this).prop('checked')) {
        $(this).closest('li').addClass('active');
      }
    });
     $('.productOption').on('change', function() {
     $('li.material__option.variant_option').removeClass('active');
     $(this).closest('li').addClass('active');
    });
  $(".popupbtn").click(function(event) {
    event.preventDefault();
    $("body").addClass("popupadded");
    var $carousel = $('.carousel').flickity({
      initialIndex: 1,
      wrapAround: true,
      autoPlay: false,
      pageDots: false,
      prevNextButtons: true
    });
    $carousel.flickity('resize');
  });

    $(".close, .close-popup").click(function(event) {
      event.preventDefault();
      $("body").removeClass("popupadded");
    });

    $(document).click(function(event) {
      if (!$(event.target).closest('.popup .image_inner').length && !$(event.target).closest('.popupbtn').length) {
        $("body").removeClass("popupadded");
      }
    });
   document.querySelector('.readmore').onclick = function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.collection-description-full');
    descriptionFull.style.display = 'block';
    var descriptionShort = document.querySelector('.collection-description-short');
    descriptionShort.style.display = 'none';
  };
  document.querySelector('.readless').onclick = function (event) {
    event.preventDefault();
    var descriptionFull = document.querySelector('.collection-description-full');
    descriptionFull.style.display = 'none';
    var descriptionShort = document.querySelector('.collection-description-short');
    descriptionShort.style.display = 'block';
  };
});
